module.exports = __webpack_public_path__ + "static/media/aus-digital-health-agency-logo.93dbd4be.png";